import axios from "axios";
import store from "@/store";

export class DealernetApi {
    public static client() {
        const baseURL = DealernetApi.getBaseURL();
        const mcfCostCenterId = store.getters.McfCostCenterId || "";
        const userId = store.state.auth?.user?.UserId || "";

        let activeAccountId = "";
        try {
            activeAccountId = store.getters.activeAccountId?.toString?.() ?? "";
        } catch (e) {
            // activeAccountId not available yet
        }

        const headers: Record<string, string> = {
            'Accept': "application/json",
            'Pragma': 'no-cache',
            'McfCostCenterId': mcfCostCenterId,
        };

        if (activeAccountId) {
            headers['AccountId'] = activeAccountId;
        }

        if (userId) {
            headers['UserId'] = userId;
        }

        const client = axios.create({
            baseURL,
            withCredentials: true,
            headers
        });

        axios.defaults.withCredentials = true;

        axios.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            //do nothing
            return response;
        }, function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            //refresh if 401
            if(error.status == 401 || error.status == "401") {
                location.reload();
            }
            return Promise.reject(error);
        });

        return client;
    }

    public static getBaseURL() {
        let baseURL = window.appGlobals.API_URL || "";

        if (baseURL.endsWith("/")) {
            baseURL = baseURL.substr(0, baseURL.length - 1);
        }

        return baseURL;
    }
}
